import { createReducer, on } from "@ngrx/store";
import { PermissionsState } from "./permissions.state";
import { setPermissions, setRole } from "./permissions.action";

export const initialState: PermissionsState = {
  permissions: {},
  permissionScope: 'user',
  role: null
};

export const permissionsReducer = createReducer(
    initialState,
    on(setPermissions,(state, { permissions, permissionScope }) => {

        // this entire block needs to removed once if the permissions are dynamic
        const userPermissions = permissions ? permissions : {}
        return { ...state, permissions: userPermissions, permissionScope };

       // return { ...state, permissions };

    }),
    on(setRole, (state, {role}) => {

        const userRole = role == 'a' ? 'admin' : 'user';
        localStorage.setItem('role', userRole);
        return { ...state, role: userRole };

        //return { ...state, role };
    })
)
